import React, { createContext } from 'react';
import http from '../utils/httpFacade';

export const PackageContext = createContext();

const PackageContextProvider = ({ children }) => {
  const getPackages = async () => {
    try {
      return await http.get({ url: 'packages' });
    } catch (error) {
      return error.data;
    }
  };

  return <PackageContext.Provider value={{ getPackages }}>{children}</PackageContext.Provider>;
};

export default PackageContextProvider;
